import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageSectionsContent } from "../components/NewsManagement/Sections/ManageSectionsContent";

export const ManageSections = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageSectionsContent />
        </div>
      </div>
    </div>
  );
};
